<template>
  <detail-layout>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <base-collapsible-form 
              ref="baseCollapsibleGeneral"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('app.general_information')}}</h4>
              </template>
              <template slot="content">

                <div>
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('app.code') }}
                      <base-tooltip-icon size="sm" :content="$t('administrativecenter.codigo_tooltip')" class="ml-2 inline-block" />
                    </label>
                    <el-form-item prop="CentreCode">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.CentreCode"
                        :maxlength="codeMaxLength"
                        :disabled="isRoleUserConsultaProvider"
                      />
                    </el-form-item>
                  </div>
                </div>
                
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$tc('app.role', 1)}}
                    <base-tooltip-icon size="sm" :content="$t('administrativecenter.rol_tooltip')" class="ml-2 inline-block" />
                  </label>
                  <el-form-item prop="RoleCode">
                    <el-select class="w-full" 
                      clearable
                      filterable
                      v-model="form.RoleCode"
                      :disabled="isRoleUserConsultaProvider" >
                        <el-option
                          v-for="opt in tiposRolAdministrativeCenter"
                          :key="opt.id"
                          :label="opt.name"
                          :value="opt.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <base-collapsible-form 
                  ref="baseCollapsibleOtherData"
                  class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                  <template slot="headerRight">
                    <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('administrativecenter.other_data') }}</h4>
                  </template>
                  <template slot="content">

                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.name') }}</label>
                      <el-form-item prop="Name">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.Name"
                          maxlength='40'
                          :disabled="isRoleUserConsultaProvider"
                        />
                      </el-form-item>
                    </div>

                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('persons_data.firstsurname') }}</label>
                      <el-form-item prop="FirstSurname">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.FirstSurname"
                          maxlength='40'
                          :disabled="isRoleUserConsultaProvider"
                        />
                      </el-form-item>
                    </div>

                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('persons_data.secondsurname') }}</label>
                      <el-form-item prop="SecondSurname">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.SecondSurname"
                          maxlength='40'
                          :disabled="isRoleUserConsultaProvider"
                        />
                      </el-form-item>
                    </div>

                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.PhysicalGLN') }}</label>
                      <el-form-item prop="PhysicalGLN">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.PhysicalIGLN"
                          maxlength='14'
                          :disabled="isRoleUserConsultaProvider"
                        />
                      </el-form-item>
                    </div>

                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.LogicalOperationalPoint') }}</label>
                      <el-form-item prop="LogicalOperationalPoint">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.LogicalOperationalPoint"
                          maxlength='14'
                          :disabled="isRoleUserConsultaProvider"
                        />
                      </el-form-item>
                    </div>

                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.CentreDescription') }}</label>
                      <el-form-item prop="CentreDescription">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.CentreDescription"
                          maxlength='2500'
                          type="textarea"
                          :rows="3"
                          :disabled="isRoleUserConsultaProvider"
                        />
                      </el-form-item>
                    </div>

                  </template>
                </base-collapsible-form>

              </template>
            </base-collapsible-form>
            
            <base-collapsible-form 
              ref="baseCollapsibleAddress"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('address.location')}}</h4>
              </template>
              <template slot="content">
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.location_long') }}</label>
                  <el-form-item prop="Address">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Address"
                      maxlength='100'
                      :disabled="isRoleUserConsultaProvider"
                    />
                  </el-form-item>
                </div>
              
                <div class="w-full">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.codigo_postal') }}</label>
                  <el-form-item prop="PostCode">
                    <el-input
                      clearable
                      class="w-full"
                      v-model.number="form.PostCode"
                      maxlength='5'
                      :disabled="isRoleUserConsultaProvider"
                    />
                  </el-form-item>
                </div>

                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.poblacion') }}</label>
                  <el-form-item prop="Town">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Town"
                      maxlength='50'
                      :disabled="isRoleUserConsultaProvider"
                    />
                  </el-form-item>
                </div>
                           
                <div class="w-full">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.provincia') }}</label>
                  <el-form-item prop="Province">
                    <el-input v-if="!isSpain"
                      clearable
                      class="w-full"
                      v-model="form.Province"
                      maxlength='20'
                      :disabled="isRoleUserConsultaProvider"
                    />
                    <el-select v-else
                      class="w-full" 
                      v-model="form.Province" 
                      filterable
                      clearable 
                      :placeholder="$t('app.select')"
                      :disabled="isRoleUserConsultaProvider">
                      <el-option
                        v-for="opt in listProvincias"
                        :key="opt.id"
                        :label="opt.name"
                        :value="opt.name">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                    
                <div >
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.pais')}}</label>
                  <el-form-item prop="CountryCode" ref="CountryCode">
                    <el-select class="w-full" 
                      v-model="form.CountryCode"
                      filterable 
                      :disabled="isRoleUserConsultaProvider">
                      <el-option
                        v-for="opt in listPaises"
                        :key="opt.id"
                        :label="opt.name"
                        :value="opt.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>

              </template>
            </base-collapsible-form>

            <base-collapsible-form 
              ref="baseCollapsibleContactDetails"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('contacto.ContactDetails') }}</h4>
              </template>
              <template slot="content">
            
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.telefono') }}</label>
                  <el-form-item prop="Telephone">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Telephone"
                      maxlength='15'
                      :disabled="isRoleUserConsultaProvider"
                    />
                  </el-form-item>
                </div>
              
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.telefax') }}</label>
                  <el-form-item prop="TeleFax">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.TeleFax"
                      maxlength='15'
                      :disabled="isRoleUserConsultaProvider"
                    />
                  </el-form-item>
                </div>
              
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.WebAddress') }}</label>
                  <el-form-item prop="WebAddress">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.WebAddress"
                      :disabled="isRoleUserConsultaProvider"
                    />
                  </el-form-item>
                </div>
              
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.ElectronicMail') }}</label>
                  <el-form-item prop="ElectronicMail">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.ElectronicMail"
                      maxlength='60'
                      :disabled="isRoleUserConsultaProvider"
                    />
                  </el-form-item>
                </div>
              
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.ContactPersons') }}</label>
                  <el-form-item prop="ContactPersons">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.ContactPersons"
                      maxlength='40'
                      :disabled="isRoleUserConsultaProvider"
                    />
                  </el-form-item>
                </div>
              
                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.CnoCnae') }}</label>
                    <el-form-item prop="CnoCnae">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.CnoCnae"
                        minlength='5'
                        maxlength='5'
                        :disabled="isRoleUserConsultaProvider"
                      />
                    </el-form-item>
                  </div>
                
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.INETownCode') }}</label>
                    <el-form-item prop="INETownCode">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.INETownCode"
                        maxlength='9'
                        :disabled="isRoleUserConsultaProvider"
                      />
                    </el-form-item>
                  </div>
                </div>
            
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.AdditionalContactDetails') }}</label>
                  <el-form-item prop="AdditionalDetails">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.AdditionalDetails"
                      maxlength='60'
                      :disabled="isRoleUserConsultaProvider"
                    />
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>
          </div>
        </el-form>
      </div>
    </template>
  </detail-layout>
</template>

<script>

import { i18n } from '@/i18n'
import { email as emailRegex } from '@/utils/regex'

import DetailLayout from '@/components/layout/DetailLayout.vue'


function isValidEmail (value) {
  if (value) return value.split(';').every(item => emailRegex.test(item))
  return false
}

export default {
  name: 'detalle-administrative-centre',
  components: {
    DetailLayout,
  },
  props: {
    form: {
      type: Object,
    },
  },
  data: function () {
    return {
      codeMaxLength: 10,
      rules: {
        CentreCode: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.CentreCode) {
                callback(new Error(i18n.t('app.fill_data')))
              } else if (this.form.CentreCode.length > this.codeMaxLength) {
                callback(new Error(i18n.t('validation.length_max', { maxLength: this.codeMaxLength })))
              } else {
                callback()
              }
            }
          },
        ],
        RoleCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        Address: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        PostCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
          {
            required: true,
            message: i18n.t('validation.length_number') + i18n.tc('app.n_character', 5),
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!this.isSpain) {
                callback()
              } else {
                var onlyFiveNumbers = /^\d{5}$/
                if (!onlyFiveNumbers.test(value)) {
                  callback(new Error())
                } else {
                  callback()
                }
              }
            }
          },
        ],
        WebAddress: [
          {
            required: false,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.WebAddress === '') {
                callback()
              } else if (this.form.WebAddress.length > 60) {
                callback(new Error(i18n.t('validation.length_max', { maxLength: 60 })))
              } else {
                callback()
              }
            }
          },
        ],
        CnoCnae: [
          {
            required: false,
            message: i18n.t('validation.length_min_number') + i18n.tc('app.n_character', 5),
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (value) {
                var onlyFiveNumbers = /^\d{5}$/
                if (!onlyFiveNumbers.test(value)) {
                  callback(new Error())
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
        ],
        Town: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        ElectronicMail: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        Province: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        CountryCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
      },
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    idSede: function () {
      return parseInt(this.$route.params.idSede)
    },
    idCentro: function () {
      return parseInt(this.$route.params.idCentro)
    },
    isCreate: function () {
      return this.idCentro === -1
    },
    isSpain: function () {
      return this.form.CountryCode.toUpperCase() === 'ESP'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    listProvincias: function () {
      return this.$store.getters['config/PROVINCIAS']
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
    tiposRolAdministrativeCenter: function () {
      return this.$store.getters['config/TIPOS_ROL_ADMINISTRATIVE_CENTER']
    },
  },
  mounted () {
    this.$refs.baseCollapsibleGeneral.toggle()
    this.$refs.baseCollapsibleAddress.toggle()
    // this.$refs.baseCollapsibleOtherData.toggle()
    // this.$refs.baseCollapsibleContactDetails.toggle()
  },
  methods: {
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else {
        callback()
      }
    },

    resetForm: function () {
      this.$refs.ruleForm.resetForm()
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        callback(valid)
      })
    },
  },
}
</script>

<style>

</style>
